export const VehicleSwapBatteryConfig = {
  api: {},
  events: {
    name: 'vehicle-swap-battery',
    // refresh-index-data
    refresh: `rid-vehicle-swap-battery`,
    // slideover-right
    sorId: 'vehicle-swap-battery',
    sorOpen: (id) => `sor-open-vehicle-swap-battery-${id}`,
    sorClose: (id) => `sor-close-vehicle-swap-battery-${id}`,
    sorToggle: (id) => `sor-toggle-vehicle-swap-battery-${id}`,
    // editing-data
    editingData: 'edit-vehicle-swap-battery-data',
    // viewing-data
    viewingData: 'view-vehicle-swap-battery-data',
  },
}
